import React, { Component } from "react";

import SitecontactDetails from "./sitecontactDetails";
import Menu from "./menu";

class MenuAndContact extends Component {

  render() {
    return (
      <div>
        <Menu />
        <SitecontactDetails />
        <span></span>
      </div>
    );
  }
}
export default MenuAndContact;
